import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'error']
  static values = { message: String }

  connect() {
    this.form = this.inputTarget.closest('form')
    if (this.form) {
      this.boundPreventSubmit = this.preventSubmit.bind(this)
      this.form.addEventListener('submit', this.boundPreventSubmit)
    }
  }

  disconnect() {
    if (this.form) {
      this.form.removeEventListener('submit', this.boundPreventSubmit)
    }
  }

  validate() {
    if (this.isInvalid()) {
      this.showError()
    } else {
      this.hideError()
    }
  }

  preventSubmit(event) {
    if (this.isInvalid()) {
      event.preventDefault()
      this.showError()
    }
  }

  isInvalid() {
    const input = this.inputTarget
    return input.max && input.value && input.value > input.max
  }

  showError() {
    this.inputTarget.classList.add('is-invalid')
    this.errorTarget.textContent = this.messageValue
    this.errorTarget.classList.remove('d-none')
  }

  hideError() {
    this.inputTarget.classList.remove('is-invalid')
    this.errorTarget.classList.add('d-none')
  }
}
